import accessLevelsList from './actions/accessLevelsList';
import createAccessLevel from './actions/createAccessLevel';
import getAccessLevel from './actions/getAccessLevel';
import updateAccessLevel from './actions/updateAccessLevel';
import getAccessLevels from './getters/getAccessLevels';
import uploadAccessLevels from './mutations/uploadAccessLevels';

const actions = {
    accessLevelsList,
    getAccessLevel,
    createAccessLevel,
    updateAccessLevel
};

const mutations = {
    uploadAccessLevels
};

const getters = {
    getAccessLevels
};

export default { actions, mutations, getters };
